module.exports = __webpack_public_path__ + "img/ic_dph_ok.dd23cd34.png";